import { RouterProvider } from 'react-router-dom';
import { AppThemeProvider } from '@/store/ThemeContext';
import { AuthProvider } from '@/store/AuthContext';
import { SettingsProvider } from '@/store/SettingsContext';
import { router } from '@/routes';

export function App() {
  return (
    <AppThemeProvider>
      <SettingsProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </SettingsProvider>
    </AppThemeProvider>
  );
}

